<template>
  <div class="home">
    <div class="inspection-content">
      <div class="section-title">检测信息
        <span class="sub-title">以下信息由检测单位提供
        <text v-if="showWarning" style="color: red">
        （暂无检测信息）
        </text>
      </span>
      </div>
      <div v-for="index in mainData" :key="index.id">
        <div class="inspection-card" v-if="mainData[0].sampleName != null">
          <div class="merchant-name">{{ index.sampleName }}</div>
          <div class="merchant-name">{{ index.place.placeName }}</div>
          <div class="info-row">
            <div class="info-label">检测项目</div>
            <div class="info-value">{{ index.testItem }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">检测结果</div>
            <div class="info-value highlight">
              <div v-if="index.checkResult==='阴性'||index.checkResult==='复测：阴性'||index.checkResult==='合格'">
                <div style="color: #2e882e">
                  {{ index.checkResult }}
                </div>
              </div>
              <div v-else>
                <div style="color: #b9252c">
                  {{ index.checkResult }}
                </div>
              </div>
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">检测单位</div>
            <div class="info-value">{{ index.createBy }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">检测日期</div>
            <div class="info-value">{{ index.checkDate }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">样品产地/档口编号</div>
            <div class="info-value">{{ index.producer }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MerchantDetail",
  props: {
    mainData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showWarning: false
    };
  },
  watch: {
    mainData: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal == undefined) {
          this.showWarning = false;
        } else if (newVal[0].sampleName == null) {
          this.showWarning = true;
        }
      }
    }
  }
};
</script>
<style scoped>
.search-input input {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
  outline: none;
}

.search-input button {
  padding: 6px 12px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}

/* 检测信息内容样式 */
.inspection-content {
  padding: 15px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.sub-title {
  font-size: 14px;
  font-weight: normal;
  color: #999;
}

.inspection-card {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
}

.merchant-name {
  font-weight: bold;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px dashed #eee;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
}

.info-label {
  width: 120px;
  color: #666;
}

.info-value {
  flex: 1;
  color: #333;
  text-align: right;

}

.highlight {
  font-weight: bold;
}

</style>
